module.exports = __webpack_public_path__ + "img/internet_archive.f39a30c1.png";